<template >
    <div class="userInfo" :class="{ 'userInfo--platform': isPlatformVariant }">
        <div class="userInfo__icons">
            <button
                v-if="isPlatformVariant"
                type="button"
                class="userInfo__icon-btn"
                aria-label="Уведомления"
                @click="openNotifications()"
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4B5563" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                    <path d="M13.73 21a2 2 0 01-3.46 0"/>
                </svg>
                <span v-if="unreadCount > 0" class="userInfo__icon-badge" />
            </button>
            <div v-else class="bell" @click="afterNotice = true">
                <img src="@/assets/icons/bell.svg" @click="openNotifications()" v-if="notices.length == 0"/>
                <img src="@/assets/icons/redBell.svg" @click="openNotifications()" v-else/>
                <div class="bell__number">
                    <p>{{ this.unreadCount }}</p>
                </div>
            </div>
            <div class="notice" :class="{ 'notice--platform': isPlatformVariant }" v-if="openNotice">
            <img src="@/assets/icons/exit.svg" @click="openNotice = false" class="exit">
            <div class="notice__top">
                <p class="notice__top__title">Центр уведомлений</p>
                <div class="notice__top__count">{{ this.unreadCount }}</div>
            </div>
            <div class="line"></div>
            <div class="notice__block">
                <div class="notice__block__in" v-for="item in notices" :key="item">
                    <div class="notice__block__in__top" v-if="item.type == 'assignment' || item.type == 'course_deadline' || item.type == 'other' || item.type === 'scholarship_deadline' || item.type === 'approved_program_deadline'">
                        <div class="notice__block__in__top__left">
                            <img src="@/assets/icons/system.svg"/>
                            <div class="notice__block__in__top__left__info">
                                <div class="notice__block__in__top__left__info__top" :class="{assignment: item.data?.assignment}">
                                    <p class="name" v-if="$store.state.role == 'user'">Система</p>
                                    <p class="name" v-else>{{ item?.data?.client_name }} ID:{{ item?.data?.client_id }}</p>
                                    <p class="status">{{ item.body }} <span v-if="item.type == 'other'">{{ item?.remained }}</span></p>
                                    <p class="statusTime" :style="{color: item.color}" >{{ item?.data?.date }}</p>
                                </div>
                                <p class="date">{{ item.time }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="notice__block__in__top" v-if="item.type == 'approval_request'">
                        <div class="notice__block__in__top__left">
                            <img src="@/assets/icons/system.svg"/>
                            <div class="notice__block__in__top__left__info">
                                <div class="notice__block__in__top__left__info__top">
                                    <p class="name"><span>Эксперт</span> {{ item?.data?.expert_name }} ID:{{ item?.data?.expert_id }}</p>
                                    <p class="status">{{ item.body }}</p>
                                    <p class="name">{{ item?.data?.client_name }} ID:{{ item?.data?.client_id }}</p>
                                </div>
                                <p class="date">{{ item.time }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="notice__block__in__comments" v-if="item.type == 'comment' || item.type == 'comment_feedback'">
                        <div class="correct">
                            <div class="correct__top">
                                <img src="@/assets/icons/system.svg"/>
                                <div class="correct__top__info">
                                    <div class="correct__top__info__top">
                                        <p class="name" v-if="item.type == 'comment'">НО12 {{ item.data.chief_name }} ID:{{ item.data.chief_id }}</p>
                                        <p class="name" v-if="item.type == 'comment_feedback'">{{ item.data.client_name }} ID:{{ item.data.client_id }}</p>
                                        <p class="status">{{ item.body }} <span v-if="item.type == 'comment_feedback'">о программе {{ item.data.program_name }}</span></p>
                                        <p class="status" :style="{color: item.color}">{{ item.title }}</p>
                                        <p class="name" v-if="item.type == 'comment'">{{ item.data.client_name }} ID:{{ item.data.client_id }}</p>
                                    </div>
                                    <!-- Ссылка на файл -->
                                    <p v-if="item.data.file_url">
                                        <a
                                            :href="item.data.file_url"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="file-link"
                                        >
                                            📎 Скачать прикреплённый файл
                                        </a>
                                    </p>
                                    <p class="date">{{ item.time }}</p>
                                </div>
                            </div>
                            <textarea v-model="item.text"></textarea>
                            <button v-if="item.type == 'comment_feedback'" @click="$router.push(`/programs/${item.data.program_id}`)">Перейти</button>
                            <button v-if="item.data.status == 'rejected'" @click="$router.push(`/curator/users/${item.data.client_id}?tab=3`)">Исправить</button>
                            <button v-if="item.data.status == 'approved'" @click="$router.push(`/curator/users/${item?.data?.client_id}?tab=4`)">Открыть</button>
                        </div>
                    </div>
                    <div class="line"></div>
                </div>
                <div class="notice__block__in" v-for="item in oldNotices" :key="item">
                    <div class="notice__block__in__top" v-if="item.type == 'assignment' || item.type == 'course_deadline' || item.type == 'other' || item.type === 'scholarship_deadline' || item.type === 'approved_program_deadline'">
                        <div class="notice__block__in__top__left">
                            <img src="@/assets/icons/system.svg"/>
                            <div class="notice__block__in__top__left__info">
                                <div class="notice__block__in__top__left__info__top" :class="{assignment: item.data?.assignment}">
                                    <p class="name" v-if="$store.state.role == 'user'">Система</p>
                                    <p class="name" v-else>{{ item?.data?.client_name }} ID:{{ item?.data?.client_id }}</p>
                                    <p class="status">{{ item.body }} <span v-if="item.type == 'other'">{{ item?.remained }}</span></p>
                                    <p class="statusTime" :style="{color: item.color}" >{{ item?.data?.date }}</p>
                                </div>
                                <p class="date">{{ item.time }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="notice__block__in__top" v-if="item.type == 'approval_request'">
                        <div class="notice__block__in__top__left">
                            <img src="@/assets/icons/system.svg"/>
                            <div class="notice__block__in__top__left__info">
                                <div class="notice__block__in__top__left__info__top">
                                    <p class="name"><span>Эксперт</span> {{ item?.data?.expert_name }} ID:{{ item?.data?.expert_id }}</p>
                                    <p class="status">{{ item.body }}</p>
                                    <p class="name">{{ item?.data?.client_name }} ID:{{ item?.data?.client_id }}</p>
                                </div>
                                <p class="date">{{ item.time }}</p>
                                <br>
                                <button @click="$router.push(`/curator/users/${item?.data?.client_id}?tab=3`)">Открыть</button>
                            </div>
                        </div>
                    </div>
                    <div class="notice__block__in__comments" v-if="item.type == 'comment' || item.type == 'comment_feedback'">
                        <div class="correct">
                            <div class="correct__top">
                                <img src="@/assets/icons/system.svg"/>
                                <div class="correct__top__info">
                                    <div class="correct__top__info__top">
                                        <p class="name" v-if="item.type == 'comment'">НО12 {{ item.data.chief_name }} ID:{{ item.data.chief_id }}</p>
                                        <p class="name" v-if="item.type == 'comment_feedback'">{{ item.data.client_name }} ID:{{ item.data.client_id }}</p>
                                        <p class="status">{{ item.body }} <span v-if="item.type == 'comment_feedback'">о программе {{ item.data.program_name }}</span></p>
                                        <p class="status" :style="{color: item.color}">{{ item.title }}</p>
                                        <p class="name" v-if="item.type == 'comment'">{{ item.data.client_name }} ID:{{ item.data.client_id }}</p>
                                    </div>
                                    <!-- Ссылка на файл -->
                                    <p v-if="item.data.file_url">
                                        <a
                                        :href="item.data.file_url"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        class="file-link"
                                        >
                                        📎 Скачать прикреплённый файл
                                        </a>
                                    </p>
                                    <p class="date">{{ item.time }}</p>
                                </div>
                            </div>
                            <textarea v-model="item.text"></textarea>
                            <button v-if="item.type == 'comment_feedback'" @click="$router.push(`/programs/${item.data.program_id}`)">Перейти</button>
                            <button v-if="item.data.status == 'rejected'" @click="$router.push(`/curator/users/${item.data.client_id}?tab=3`)">Исправить</button>
                            <button v-if="item.data.status == 'approved'" @click="$router.push(`/curator/users/${item?.data?.client_id}?tab=4`)">Открыть</button>
                        </div>
                    </div>
                    <div class="line"></div>
                </div>
            </div>
        </div>
        </div>
        <div v-if="isPlatformVariant" class="userInfo__divider" />
        <div class="yesornoModalBack" v-if="openYes">
            <div class="yesornoModal">
                <div class="yesornoModal__left">
                    <p>Выберите действие</p>
                    <img src="@/assets/icons/exit.svg" @click="openYes = false"/>
                </div>
                <div class="yesornoModal__buttons">
                    <label class="yesornoModal__buttons__redactor" for="imageWeb">
                    Изменить
                    <input type="file" id="imageWeb" accept="image/png, image/jpeg" @change="handleFileChange" style="display: none;" />
                    </label>
                    <span @click="deleteImage()" style="background-color: red;">Удалить</span>
                </div>
            </div>
        </div>
        <div class="userInfo__profile" ref="profileMenuRef">
            <button
                type="button"
                class="userInfo__profile__btn"
                :class="{ 'userInfo__profile__btn--open': showProfileMenu }"
                @click.stop="toggleProfileMenu"
            >
                <div class="userInfo__info__left">
                    <img :src="imagePreview || userInfo.image" alt="" v-if="imagePreview || userInfo.image"/>
                    <div v-else-if="isPlatformVariant" class="userInfo__avatar-initial">{{ userInitial }}</div>
                    <img src="@/assets/icons/profile.webp" v-else/>
                </div>
                <div class="userInfo__info__right">
                    <p class="userInfo__info__right__name">
                        <span class="userInfo__info__right__name-text">{{ userInfo?.name }}</span>
                        <svg
                            v-if="showClientVerifiedIcon"
                            class="userInfo__verified-icon"
                            width="14"
                            height="14"
                            viewBox="0 0 16 16"
                            fill="currentColor"
                            aria-label="Verified"
                            role="img"
                        >
                            <path d="M10.067.87a2.89 2.89 0 0 0-4.134 0l-.622.638-.89-.011a2.89 2.89 0 0 0-2.924 2.924l.01.89-.636.622a2.89 2.89 0 0 0 0 4.134l.637.622-.011.89a2.89 2.89 0 0 0 2.924 2.924l.89-.01.622.636a2.89 2.89 0 0 0 4.134 0l.622-.637.89.011a2.89 2.89 0 0 0 2.924-2.924l-.01-.89.636-.622a2.89 2.89 0 0 0 0-4.134l-.637-.622.011-.89a2.89 2.89 0 0 0-2.924-2.924l-.89.01zm.287 5.984-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708.708"/>
                        </svg>
                    </p>
                    <p v-if="roleLabel" class="userInfo__info__right__spec">{{ roleLabel }}</p>
                </div>
                <svg class="userInfo__profile__chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
            </button>
            <div v-if="showProfileMenu" class="userInfo__profile__dropdown">
                <div class="userInfo__profile__dropdown__header">
                    <p class="userInfo__profile__dropdown__name">{{ userInfo?.name }}</p>
                    <p class="userInfo__profile__dropdown__email">{{ userInfo?.email }}</p>
                </div>
                <button
                    v-if="isPlatformClient"
                    type="button"
                    class="userInfo__profile__dropdown__item"
                    @click="goToCabinet"
                >
                    Личный кабинет
                </button>
                <button
                    v-if="isPlatformClient"
                    type="button"
                    class="userInfo__profile__dropdown__item"
                    @click="openPhotoEditor"
                >
                    Изменить фото
                </button>
                <button
                    type="button"
                    class="userInfo__profile__dropdown__item userInfo__profile__dropdown__item--danger"
                    @click="leaveAccount"
                >
                    Выйти
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import notificationSound from '@/assets/sounds/notification.mp3';
import Notice from './newPlatform/notice.vue';
import Pusher from "pusher-js";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { EventBus } from '@/eventBus'
import Echo from "laravel-echo";
export default {
    components:{
        Notice
    },
    props: {
        variant: {
            type: String,
            default: '',
        },
    },
    data(){
        return{
            isCurator: true,
            openNotice : false,
            oldNotices : false,
            afterNotice: false,
            unreadCount: 0,
            openYes: false,
            showProfileMenu: false,
            notices: [],
            pusher: null,
            imageForSend: '',
            imagePreview: '',
            audio: null,
            audioReady: false,
            echo: null,
        }
    },
    computed:{
        ...mapGetters(["userInfo"]),
        isPlatformVariant() {
            return this.variant === 'platform';
        },
        isPlatformClient() {
            return ['user', 'guest'].includes(this.$store.state.role);
        },
        userInitial() {
            const name = this.userInfo?.name || '';
            return name.charAt(0).toUpperCase() || '?';
        },
        showClientVerifiedIcon() {
            return this.isPlatformClient && !this.userInfo?.study_degree?.title;
        },
        roleLabel() {
            if (this.userInfo?.study_degree?.title) {
                return this.userInfo.study_degree.title;
            }
            if (this.showClientVerifiedIcon) {
                return '';
            }
            if (this.userInfo?.role?.name === 'supervisor') return 'НО10';
            if (this.userInfo?.role?.name === 'chief') return 'НО12';
            return this.userInfo?.role?.name || '';
        },
    },
    methods: {
        ...mapActions(['logoutUser', 'toggleBlock']),
        toggleProfileMenu() {
            this.showProfileMenu = !this.showProfileMenu;
            if (this.showProfileMenu) {
                this.openNotice = false;
            }
        },
        closeProfileMenu() {
            this.showProfileMenu = false;
        },
        onDocumentClick(event) {
            if (this.$refs.profileMenuRef && !this.$refs.profileMenuRef.contains(event.target)) {
                this.closeProfileMenu();
            }
        },
        goToCabinet() {
            this.closeProfileMenu();
            this.guestRouteFilter('/platform');
        },
        openPhotoEditor() {
            this.closeProfileMenu();
            this.openYes = true;
        },
        guestRouteFilter(path) {
            const allowedForGuest = [
                '/platform',
                '/programs',
                '/platform/intGrants',
                '/platform/schools',
                '/platform/premium',
                '/platform/useful',
            ];
            const blockedForGuest = ['/favourites', '/platform/admission'];

            if (this.$store.state.role === 'guest') {
                if (allowedForGuest.includes(path)) {
                    this.toggleBlock(false);
                    this.$router.push(path);
                } else if (blockedForGuest.includes(path)) {
                    this.toggleBlock(true);
                } else {
                    this.toggleBlock(true);
                }
            } else {
                this.toggleBlock(false);
                this.$router.push(path);
            }
        },
        leaveAccount() {
            this.closeProfileMenu();
            this.logoutUser();
            toast('Вы вышли с аккаунта.');
            this.$router.push('/');
        },
        playNotification() {
            const audio = new Audio(notificationSound);
            audio.play().catch(e => {
                console.warn('Не удалось проиграть звук', e);
            });
        },
        async getNotices() {
            try {
                const token = localStorage.getItem("access_token");
                const res = await axios.get('/notifications', {
                    headers: { Authorization: `Bearer ${token}` }
                });

                // Попробуем аккуратно извлечь массив
                const data = Array.isArray(res.data?.data)
                    ? res.data.data
                    : Array.isArray(res.data?.data?.data)
                        ? res.data.data.data
                        : [];


                console.log('Notices: ', data);

                // Разделяем уведомления
                if (this.$store.state.role != 'supervisor' && this.$store.state.role != 'chief'){
                    this.notices = data.filter(item => item.read_at === null); // непрочитанные
                    this.oldNotices = data.filter(item => item.read_at !== null); // прочитанные
                }else{
                    if(this.$store.state.role == 'supervisor'){
                        this.notices = data.filter(item => item.is_supervisor_read === 0); // непрочитанные
                        this.oldNotices = data.filter(item => item.is_supervisor_read !== 0); // прочитанные
                    }else
                    if(this.$store.state.role == 'chief'){
                        this.notices = data.filter(item => item.is_chief_read === 0); // непрочитанные
                        this.oldNotices = data.filter(item => item.is_chief_read !== 0); // прочитанные
                    }
                }

                this.unreadCount = this.notices.length;
                if(this.notices.length > 0){
                    this.playNotification();
                }
            } catch (err) {
                console.error('Ошибка загрузки уведомлений', err);
            }
        },

        subscribe() {
            const echo = this.$root.$echo;
            if (!echo) {
                console.warn('Echo ещё не инициализирован');
                return;
            }
            if (!this.userInfo?.id) return;

            // Подписка на приватный канал пользователя
            echo.private(`user.${this.userInfo.id}`)
                .listen('NotificationCreated', (payload) => {
                    // payload — то, что вернули broadcastWith()
                    console.log('Получено событие', payload);
                    this.notices.unshift(payload);
                    this.unreadCount = this.notices.length;
                    if(this.notices.length > 0){
                        this.playNotification();
                    }
                });
        },

        async openNotifications() {
            this.openNotice = !this.openNotice;
            if (this.openNotice) {
                try {
                    const token = localStorage.getItem("access_token");
                    const res = await axios.post('/notifications/mark-read', {}, {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    const data = Array.isArray(res.data?.data)
                        ? res.data.data
                        : Array.isArray(res.data?.data?.data)
                            ? res.data.data.data
                            : [];

                    if (this.$store.state.role !== 'supervisor' && this.$store.state.role !== 'chief'){
                        this.notices = data.filter(item => item.read_at === null); // непрочитанные
                        this.oldNotices = data.filter(item => item.read_at !== null); // прочитанные
                    }else{
                        if(this.$store.state.role === 'supervisor'){
                            this.notices = data.filter(item => item.is_supervisor_read === null); // непрочитанные
                            this.oldNotices = data.filter(item => item.is_supervisor_read !== null); // прочитанные
                        }
                        if(this.$store.state.role === 'chief'){
                            this.notices = data.filter(item => item.is_chief_read === null); // непрочитанные
                            this.oldNotices = data.filter(item => item.is_chief_read !== null); // прочитанные
                        }
                    }
                    this.unreadCount = 0;
                } catch (err) {
                    console.error('Ошибка при отметке прочитанных', err);
                }
            }
        },
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.imagePreview = URL.createObjectURL(file);
                this.imageForSend= file;
                const formData = new FormData();
                formData.append('image',  this.imageForSend);
                try {
                 axios.post(`/platform/upload-image`, formData, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    });
                    toast.success('Успешно обновлено!')
                    this.originalUser = { ...this.editableUser };
                    this.openYes = false;
                    setTimeout(() => {
                        this.$store.dispatch('requestUser');
                    }, 1000);
                } catch (response) {
                    toast.error(response.response.data.message);
                }
            }
        },
        deleteImage(){
            this.imagePreview = '';
            this.imageForSend = '';
            try {
                 axios.get(`/platform/remove-image`, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                        },
                    });
                    toast.success('Успешно удалено!')
                    this.originalUser = { ...this.editableUser };
                    this.openYes = false;
                    setTimeout(() => {
                        this.$store.dispatch('requestUser');
                    }, 1000);
                } catch (response) {
                    toast.error(response.response.data.message);
                }
        },
        navigateToRole(event) {
            const selectedRole = event.target.value;
            this.$store.state.role = selectedRole;
            if (selectedRole === 'user') {
                this.$router.push('/platform');
            } else if (selectedRole === 'curator') {
                this.$router.push('/curator');
            }
        }
    },
    mounted() {
        document.addEventListener('mousedown', this.onDocumentClick);
         window.addEventListener("click", () => {
            if (!this.audioReady) {
            this.audio = new Audio(notificationSound);
            this.audioReady = true;
            }
        }, { once: true });
        this.getNotices();
        this.subscribe();
        EventBus.on('open-notifications', this.openNotifications)
    },
    beforeUnmount() {
        document.removeEventListener('mousedown', this.onDocumentClick);
        // отписка
        if (this.$echo && this.userInfo?.id) {
            try { this.$echo.leave(`user.${this.userInfo.id}`); } catch(e) {}
        }
        EventBus.off('open-notifications', this.openNotifications)
    },
}
</script>
<style lang="scss" scoped>
.assignment{
    flex-direction: row-reverse !important;
}
.yesornoModalBack{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: #0000004D;
    z-index: 1002;
    display: flex;
    justify-content: center;
    align-items: center;
}
.yesornoModal{
    background: white;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: fit-content;
    padding: 20px;
    align-items: center;
    border-radius: 15px;
    width: fit-content;
    position: relative;
    &__left{
        display: flex;
        width: 100%;
        justify-content: space-between;
        img{
            width: 15px;
            cursor: pointer;
            aspect-ratio: 1;
            filter: brightness(0) saturate(100%) invert(31%) sepia(98%) saturate(7098%) hue-rotate(355deg) brightness(98%) contrast(118%);
        }
    }
    &__buttons{
        display: flex;
        gap: 20px;
        align-items: center;
        &__redactor, span{
            padding: 10px 20px;
            cursor: pointer;
            border: none;
            background-color: #11415D;
            color: white;
            border-radius: 10px;
            width: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
.line1{
    border: 1px solid #0000001A;
}
.exit{
    filter: brightness(0) saturate(100%) invert(66%) sepia(8%) saturate(11%) hue-rotate(12deg) brightness(95%) contrast(84%);
    width: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    height: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    position: absolute;
    top: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
    right: min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px);
    cursor: pointer;
}
    .line{
        border-top: 1px solid #0000001A;
        width: 100%;
    }
    .notice{
        background-color: white;
        position: absolute;
        width: 900px;
        max-height: 500px;
        overflow: auto;
        top: 110%;
        padding: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px)min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px);
        display: flex;
        border: 1px solid grey;
        flex-direction: column;
        z-index: 999;
        right: 0%;
        gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        border-radius: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        @media(max-width: 768px) {
            max-width: calc(100vw - 25px)!important;
            width: calc(100vw - 25px)!important;
            padding: 20px!important;
            right: 0!important;
            left: -90vw!important;
        }
        @media(max-width: 480px) {
            left: -77vw!important;
        }
        @media(max-width: 450px) {
            left: -80vw!important;
        }
        @media(max-width: 420px) {
            left: -90vw!important;
        }
        @media(max-width: 380px) {
            left: -100vw!important;
        }
        &__top{
            display: flex;
            flex-wrap: wrap;
            gap: 5px;
            &__title{
                font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
                font-weight: 600;
                color: #11415D;
            }
            &__count{
                width: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
                height: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
                background: #F8F8F8;
                border: 1px solid #0000001A;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #0000004D;
            }
        }
        &__block{
            display: flex;
            flex-direction: column;
            gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
            &__in{
            display: flex;
            flex-direction: column;
            gap: min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px);
            &__top{
                display: flex;
                justify-content: space-between;
                gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
                &__left{
                    display: flex;
                    gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
                    align-items: stretch;
                    &__info{
                        display: flex;
                        justify-content: space-around;
                        flex-direction: column;
                        &__top{
                            display: flex;
                            flex-wrap: wrap;
                            gap: 5px;
                            align-items: center;
                            font-size: min(max(13px, calc(0.8125rem + ((1vw - 7.68px) * 0.434))), 18px);
                            .name, .statusTime{
                                font-weight: 600;
                            }
                        }
                        .date{
                            font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))), 14px);
                            color: #0000008A;
                        }
                    }
                }
            }
            &__comments{
                display: flex;
                flex-direction: column;
                gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
            }
        }
        }
    }
    button{
        background-color: #11415D;
        color: white;
        padding: min(max(6px, calc(0.375rem + ((1vw - 7.68px) * 0.5208))), 12px);
        border: none;
        font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))), 14px);
        height: fit-content;
        border-radius: 10px;
        width: fit-content;
    }
    .correct{
    display: flex;
    flex-direction: column;
    gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    &__top{
        display: flex;
        gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        align-items: stretch;
        &__info{
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            width: 100%;
            &__top{
                display: flex;
                flex-wrap: wrap;
                gap: 5px;
                .name{
                    font-weight: 700;
                }
            }
        }
    }
    textarea{
        width: 60%;
        padding: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        border-radius: 10px;
        background-color: #11415D;
        color: white;
        font-weight: 600;
        resize: none;
        min-height: 150px;
    }
}
    .userInfo{
        width: 100%;
        display: flex;
        gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        justify-content: flex-end;
        align-items: center;
        select{
            background: transparent;
            border: none;
        }
        &__icons{
            position: relative;
        }
        .bell{
            display: flex;
            gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            padding: min(max(8px, calc(0.5rem + ((1vw - 7.68px) * 0.3472))), 12px) min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);;
            height: fit-content;
            box-shadow: 0px 0px 4px 1px #0000000D;
            border-radius: 8px;
            position: relative;
            @media (max-width: 768px) {
                display: none!important;
            }
            &__number{
                width: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.7813))), 24px);
                aspect-ratio: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                background: #F8F8F8;
                border: 1px solid #0000001A;
                font-size: 14px;
                top: -7.5px;
                left: -7.5px;
                border-radius: 50%;
            }
            img{
                width: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
                object-fit: contain;
                cursor: pointer;
            }
        }
        &__profile {
            position: relative;

            &__btn {
                display: flex;
                align-items: center;
                gap: 10px;
                padding: 6px 12px 6px 6px;
                border: none;
                border-radius: 10px;
                background: transparent;
                cursor: pointer;
                font-family: inherit;
                transition: background 0.12s;

                &--open,
                &:hover {
                    background: #f3f4f6;
                }
            }

            &__chevron {
                color: #9ca3af;
                flex-shrink: 0;
            }

            &__dropdown {
                position: absolute;
                top: calc(100% + 8px);
                right: 0;
                width: 220px;
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 10px;
                box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
                overflow: hidden;
                z-index: 300;

                &__header {
                    padding: 12px 16px 10px;
                    border-bottom: 1px solid #e5e7eb;
                }

                &__name {
                    font-size: 13px;
                    font-weight: 700;
                    color: #111827;
                    margin: 0;
                }

                &__email {
                    font-size: 12px;
                    color: #9ca3af;
                    margin: 2px 0 0;
                }

                &__item {
                    display: flex;
                    width: 100%;
                    align-items: center;
                    padding: 11px 16px;
                    border: none;
                    background: transparent;
                    font-size: 13.5px;
                    font-weight: 500;
                    color: #111827;
                    text-align: left;
                    cursor: pointer;
                    font-family: inherit;
                    transition: background 0.1s;

                    &:hover {
                        background: #f3f4f6;
                    }

                    &--danger {
                        color: #e8192c;
                        border-top: 1px solid #e5e7eb;

                        &:hover {
                            background: rgba(232, 25, 44, 0.08);
                        }
                    }
                }
            }
        }

        &__info{
            &__left{
                img{
                    width: 34px;
                    height: 34px;
                    aspect-ratio: 1;
                    border-radius: 8px;
                    object-fit: cover;
                }
            }
            &__right{
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                font-weight: 700;
                text-align: left;
                &__spec{
                    font-size: 11px;
                    color: #0bbfad;
                    text-transform: uppercase;
                    letter-spacing: 0.3px;
                    margin: 0;
                    display: flex;
                    align-items: center;
                }
                &__name{
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    font-size: 13.5px;
                    color: #111827;
                    margin: 0;
                    line-height: 1.2;
                    min-width: 0;

                    &-text {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
    }

.userInfo__verified-icon {
  color: #1d9bf0;
  flex-shrink: 0;
}

.file-link {
  color: #3498db;
  text-decoration: underline;
  text-underline-offset: 2px;
  word-break: break-all;
  display: inline-block;
  margin: 4px 0;
  transition: all 0.3s ease;

  &:hover {
    text-underline-offset: 4px;
  }
}

.userInfo--platform {
  width: auto;
  gap: 4px;
  flex-shrink: 0;

  .userInfo__icons {
    position: relative;
  }

  .userInfo__icon-btn {
    position: relative;
    width: 38px;
    height: 38px;
    border: none;
    border-radius: 8px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.12s;
    padding: 0;

    &:hover {
      background: #f3f4f6;
    }
  }

  .userInfo__icon-badge {
    position: absolute;
    top: 6px;
    right: 6px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #e8192c;
    border: 2px solid #fff;
    pointer-events: none;
  }

  .userInfo__divider {
    width: 1px;
    height: 28px;
    background: #e5e7eb;
    margin: 0 8px;
    flex-shrink: 0;
  }

  .userInfo__profile__btn {
    font-family: 'Manrope', sans-serif;
  }

  .userInfo__avatar-initial {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    background: linear-gradient(135deg, #e8192c, #ff6b35);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .userInfo__info__left img {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    object-fit: cover;
  }

  .userInfo__info__right {
    &__name {
      display: flex;
      align-items: center;
      gap: 4px;
      font-size: 13.5px;
      font-weight: 700;
      color: #111827;
      line-height: 1.2;
      min-width: 0;

      &-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    &__spec {
      font-size: 11px;
      font-weight: 700;
      color: #0bbfad;
      text-transform: uppercase;
      letter-spacing: 0.3px;
      line-height: 1.2;
      display: flex;
      align-items: center;
    }
  }

  .notice--platform {
    width: 320px;
    max-width: calc(100vw - 32px);
    right: 0;
    left: auto;
    top: calc(100% + 8px);
    padding: 0;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    max-height: 420px;

    .exit {
      top: 14px;
      right: 14px;
    }

    .notice__top {
      padding: 14px 16px 10px;
      border-bottom: 1px solid #e5e7eb;

      &__title {
        font-size: 14px;
        font-weight: 700;
        color: #111827;
      }

      &__count {
        width: auto;
        min-width: 22px;
        height: 22px;
        padding: 0 6px;
        font-size: 12px;
        background: #f3f4f6;
        border: 1px solid #e5e7eb;
        color: #6b7280;
      }
    }

    .notice__block {
      padding: 0 0 8px;
    }
  }

  @media (max-width: 768px) {
    .userInfo__icon-btn {
      display: flex !important;
    }

    .userInfo__info__right {
      display: none;
    }

    .userInfo__profile__chevron {
      display: none;
    }
  }
}
</style>